import { require200Status } from "../../utils/response.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
import { BannerConvertSpec } from "../../../types/models/banner.specs.js";
function publicBannerEndpoints(builder) {
  return {
    getPublicBanners: builder.query({
      query: ({ query }) => ({
        url: `/banner/list${parseQs(query)}`,
        validateStatus: require200Status,
        method: "GET"
      }),
      transformResponse: transformWithSpec(BannerConvertSpec)
    })
  };
}
export {
  publicBannerEndpoints as default
};
